
/**
 * @fileOverview ContentFilterController View Module File
 * This sets up a relationship between a Content List View object and a series of triggers, or links. The specific view
 * which this controller interacts with is passed in as part of the constructor.  The view has an expected interface
 * that includes a method called .filterBy() that accepts a string.
 *
 * The main filter object is passed into the constructor, and represents a triggers are identified by a common jQuery selector, passed into the constructor.  The triggers also have a custom
 * data attribute called 'data-filter-arg' which is the string passed to the view's filterBy() method.  In addition,
 * triggers can have an optional 'data-filter-default' attribute, which contains a boolean, that indicates that this is
 * the default selected state when the page loads or the view resets do to a global event.
 *
 * NOTE: THIS REQUIRE MODULE IS NAME SPACED, AND NEEDS TO HAVE ITS WRAPPER FUNCTION REMOVED IN ORDER TO REUSE ELSEWHERE *
 *
 * @author Jeff Maki <jmaki@nerdery.com>
 * @version 1.0
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/ContentFilterController',['require','jquery','lib/Util','GlobalEventDispatcher'],function (require) {

        var $ = require('jquery');
        var Util = require('lib/Util');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');

        /**
         * Description
         *
         * @name ContentFilterController
         * @class ContentFilterController - Used to update a view, filtering it down to a specific matched set of content
         * @constructor
         * @param {String} filterSelector, a valid jQuery selector that is shared among all triggers in a set
         * @param {ContentSliderView} contentView, a view object that handles the displaying of the content to be filtered
         *
         * @since 1.0
         */
        var ContentFilterController = function (filterSelector, contentView) {

            /**
             * The parent element that contains the filter triggers, triggers that are part of the same set must be
             * child elements of this DOM object.
             *
             * @type {jQuery|HTMLElement}
             */
            this.$filter = $(filterSelector);

            /**
             *
             * @type {EventDispatcher}
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();
            this.$triggers = undefined;
            this.$defaultTrigger = undefined;
            this.view = contentView;
            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         *
         * @returns {ContentFilterController}
         * @since 1.0
         */
        ContentFilterController.prototype.init = function () {
            this.isEnabled = false;
            $debug('ContentFilterController.js loaded');
            return this.setupHandlers()
                .createChildren()
                .layout()
                .enable();
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @returns {ContentFilterController}
         * @since 1.0
         */
        ContentFilterController.prototype.setupHandlers = function () {
            // Bind event handlers scope here
            this.onClickHandler = this.onClick.bind(this);

            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.resetFilterController.bind(this));

            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @returns {ContentFilterController}
         * @since 1.0
         */
        ContentFilterController.prototype.createChildren = function () {
            this.$triggers = this.$filter.find('.js-contentFilterTrigger');

            var $defaultTrigger = this.$triggers.filter('[data-filter-default="true"]');

            if ($defaultTrigger.length > 0) {
                this.$defaultTrigger = this.$triggers.filter('[data-filter-default="true"]');
            }

            return this;
        };

        /**
         * Performs measurements and applys any positiong style logic
         * Should be run anytime the parent layout changes
         *
         * @returns {ContentFilterController}
         * @since 1.0
         */
        ContentFilterController.prototype.layout = function () {
            // Insert any layout or measurement logic here

            return this;
        };

        /**
         * Enables the view
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @returns {ContentFilterController}
         * @since 1.0
         */
        ContentFilterController.prototype.enable = function () {
            if (this.isEnabled) {
                return this;
            }

            this.isEnabled = true;

            this.$triggers.on('click', this.onClickHandler);

            return this;
        };

        /**
         * Disables the view
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @returns {ContentFilterController}
         * @since 1.0
         */
        ContentFilterController.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            }

            this.isEnabled = false;

            // Tear down any event handlers

            return this;
        };

        /**
         * Destroys the view
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @returns {ContentFilterController}
         * @since 1.0
         */
        ContentFilterController.prototype.destroy = function () {
            this.disable();

            return this;
        };

        /**
         * Used to reset the filter controls to their base state, can be expanded to set an initial selection
         * if needed.
         */
        ContentFilterController.prototype.resetFilterController = function () {
            this.$triggers.removeClass('MMM--isActive');

            if (this.$defaultTrigger !== undefined) {
                this.$defaultTrigger.addClass('MMM--isActive');
            }
        };

        /**
         * onClick Handler
         * Takes the targets filter-arg data tag, and passes it as an argument to the views filterBy() method.  Also,
         * manages which trigger is set to active.
         *
         * @param {MouseEvent} event Click event
         * @since 1.0
         */
        ContentFilterController.prototype.onClick = function (event) {
            var $trigger = $(event.currentTarget);
            var filterParameter = $trigger.data('filter-arg');

            //needed for IE Support
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }

            // remove the isActive class from the trigger elements
            this.$triggers.removeClass('MMM--isActive');

            //apply the isActive class to the new trigger element
            $trigger.addClass('MMM--isActive');

            //call the filter event on the view, using the filterParameter defined by the trigger element
            this.view.filterBy(filterParameter);
        };

        return ContentFilterController;
    });

}(MMMRequire));